import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { gitConnectionSync } from '../../docs-routes'

const LastSyncAttempt = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Suites and snippets will be automatically synced every few minutes. If you need to sync them immediately you can use the `Sync suites and snippets` button.
    </Color>
    <DocusaurusFooter path={gitConnectionSync} />
  </Paragraph>

export default LastSyncAttempt
